export const showHideReplaceReceiverSpecificLabels = ({ currentAction }) => {
    const productTitleForOtherActionsThanReplace = document.querySelector('.configurator_info-main-product').querySelector('.configurator_info__title');
    const elementsReplaceReceiverSpecific = [
        document.querySelector('.mainProductForReplaceReceiversAndLossDamage'),
        document.querySelector('.reasonTitleForReplaceReceiversAndLossDamage'),
        document.querySelector('.reasonDescriptionForReplaceReceiversAndLossDamage')
    ];
    const dropdownPlaceholderEl = document.querySelector('.relatedProducts__dropdown-holder').querySelector('.form-select__placeholder');
    const elementsNotReplaceReceiverSpecific = [
        productTitleForOtherActionsThanReplace,
        document.querySelector('.reasonTitleBasic'),
        document.querySelector('.reasonDescriptionBasic')
    ];
    if (currentAction !== 'ReplaceReceiver' && currentAction !== 'LostAndDamage') {
        elementsReplaceReceiverSpecific.forEach(i => i.classList.add('hidden'));
        elementsNotReplaceReceiverSpecific.forEach(i => i.classList.remove('hidden'));
        dropdownPlaceholderEl.innerText = dropdownPlaceholderEl.getAttribute('data-basic-dropdown-watermark');

    } else if (currentAction === 'ReplaceReceiver') {
        elementsReplaceReceiverSpecific.forEach(i => i.classList.remove('hidden'));
        elementsNotReplaceReceiverSpecific.forEach(i => i.classList.add('hidden'));
        dropdownPlaceholderEl.innerText = dropdownPlaceholderEl.getAttribute('data-replace-receivers-dropdown-watermark');
    } else if (currentAction === 'LostAndDamage') {
        elementsReplaceReceiverSpecific.forEach(i => i.classList.remove('hidden'));
        elementsNotReplaceReceiverSpecific.forEach(i => i.classList.add('hidden'));
        dropdownPlaceholderEl.innerText = dropdownPlaceholderEl.getAttribute('data-basic-dropdown-watermark');
    }
}